import React from "react";

type Props = {
  className?: string;
  fill?: string;
  stroke?: string;
};

const LookIcon = ({
  className = "",
  fill = "none",
  stroke
}: Props) => (
  <svg width={20} height={14} className={className}>
    <g
      fill={fill}
      fillRule="evenodd"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1 1)"
    >
      <path d="M.161 6.502A.87.87 0 01.16 5.496C1.177 4.052 4.439 0 9 0c4.523 0 7.807 4.046 8.838 5.493a.87.87 0 01-.002 1.012C16.798 7.95 13.488 12 9 12 4.474 12 1.187 7.944.161 6.502z" />
      <circle cx={9.001} cy={6} r={3.6} />
    </g>
  </svg>
);

export default LookIcon;
